import ShipperSaveDetail from "@/classes/models/ShipperSaveDetail";
import ContactDetail from "@/classes/bookings/ContactDetail";

export default class Address extends ShipperSaveDetail{
    constructor() {
        super();

        this.newCompanySaved = false;
        this.selectedContact = new ContactDetail();
    }
}
